import { css } from '@emotion/css';

import { Colors, FontWeight, Spacing } from '../../styles/constants';

export const notFoundContainer = css({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  height: '100vh',
  padding: `0 ${Spacing.LG}px`,
  width: '100%',
});

export const headingClassName = css({
  color: Colors.Primary,
  fontSize: 44,
  fontWeight: FontWeight.BOLD,
  marginBottom: Spacing.MD,
});

export const subheadingClassName = css({
  color: Colors.Secondary,
  fontSize: 22,
  fontWeight: FontWeight.MEDIUM,
  textAlign: 'center',
});

export const buttonClassName = css({
  borderRadius: 100,
  marginTop: Spacing['2XL'],
});
